import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState, useEffect } from 'react';
import { FiCheck, FiX } from 'react-icons/fi';

type CreateCurriculumStepperProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  currentErrorStep: number | null;
  isEditingExisting?: boolean;
};

const steps = [
  'text861',
  'text3418',
  'text863',
  'text864',
  'text1742',
  'text866',
  'text3419',
  'text867',
];

export const CreateCurriculumStepper = ({
  currentStep,
  setCurrentStep,
  currentErrorStep,
  isEditingExisting = false,
}: CreateCurriculumStepperProps) => {
  const { t } = useTranslations();
  const [clickedStepsIndexes, setClickedStepsIndexes] = useState<number[]>(
    isEditingExisting ? steps.map((_, index) => index) : [],
  );
  const [lastClickedStep, setLastClickedStep] = useState<number | null>(null);

  useEffect(() => {
    if (currentStep !== null) {
      setLastClickedStep(prevLastStep => {
        if (prevLastStep !== currentStep) {
          if (lastClickedStep != null && !clickedStepsIndexes.includes(lastClickedStep)) {
            setClickedStepsIndexes(prevIndexes => [...prevIndexes, lastClickedStep]);
          }
          return currentStep;
        }
        return prevLastStep;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <div className="hidden pr-4 md:block md:min-w-[300px] md:max-w-[300px]">
      <div className="mb-4 flex flex-col gap-1 text-base leading-[20px]">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`flex cursor-pointer items-center gap-3 rounded-lg p-4 text-black hover:bg-white ${
              currentStep === index ? 'bg-white font-bold' : 'pr-7 font-normal'
            }`}
            onClick={() => setCurrentStep(index)}
          >
            <div
              className={cn(
                'flex max-h-5 min-h-5 min-w-5 max-w-5 items-center justify-center rounded-full border border-border bg-white',
                index === currentStep && 'bg-white',
                clickedStepsIndexes.includes(index) && 'bg-primary',
                currentErrorStep === index && 'bg-red-500',
              )}
            >
              {clickedStepsIndexes.includes(index) && index !== currentErrorStep && (
                <FiCheck className="text-white" />
              )}
              {currentErrorStep === index && <FiX className="text-white" />}
            </div>
            <div>{t(step)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
